// src/components/dayClose/AnimatedRippleNumber.tsx
// 帶動畫的 Ripples 數字顯示

import React, { useState, useEffect } from 'react';

interface AnimatedRippleNumberProps {
  value: number;
  className?: string;
  prefix?: string;
  duration?: number;
}

export const AnimatedRippleNumber: React.FC<AnimatedRippleNumberProps> = ({
  value,
  className = '',
  prefix = '+',
  duration = 1000
}) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    let startTime: number | null = null;
    const startValue = 0;
    const endValue = value;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);

      // 使用 easeOutQuart 緩動函數
      const easeOutQuart = 1 - Math.pow(1 - percentage, 4);
      const currentValue = Math.floor(startValue + (endValue - startValue) * easeOutQuart);

      setDisplayValue(currentValue);

      if (percentage < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [value, duration]);

  return (
    <span className={`inline-block ${className}`}>
      {prefix}{displayValue}
    </span>
  );
};

interface AnimatedTotalProps {
  value: number;
  className?: string;
}

export const AnimatedTotal: React.FC<AnimatedTotalProps> = ({
  value,
  className = ''
}) => {
  return (
    <span className={className}>
      (Total {value.toLocaleString()})
    </span>
  );
};
